import { MediaType } from "../../../types";
import { BaseTheBaseMeshAsset } from "./base";
import { TheBaseMeshAsset } from "../types";

export class Model3DAsset extends BaseTheBaseMeshAsset {
  constructor(file: TheBaseMeshAsset) {
    super(file);
  }

  getMediaType() {
    return MediaType.Model3D;
  }

  getDownloadUrl(): string {
    return this.asset.model;
  }

  getMetadata() {
    return {
      status: 'ready',
      date: '',
      size: 0,
      license: 'CC0 License',
      authors: ['Tim Steer'],
    };
  }
}
